<section>
    <div class="wrapper">
        <article class="mrt-75 article" *ngIf="!isPageError">
            <div>
                <div class="content">
                    <div class="main-action-col main-col">
                        <div class="row-top">
                            <div class="row">
                                <div class="col-sm-5">
                                    <h2 class="title">Devices Data</h2>
                                </div>
                                <div class="col-sm-7">
                                    <div class="cam-pagination-listsImg">
                                        <div class="innerRightActions">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="responsive align">            
                    <div class="header-section">
                        <div class="dropdown">
                            <div class="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-bars"></i>
                            </div>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <div class="checkbox-list">
                                 <label style="font-weight: bold;">
                                        <input type="checkbox" [(ngModel)]="selectAll" (change)="toggleAllColumns(selectAll)"> Select all
                                 </label>
                                  <label *ngFor="let column of getColumnVisibilityKeys()" class="col-lable">
                                    <input type="checkbox" [(ngModel)]="columnVisibility[column]" (change)="onColumnVisibilityChange(column)" 
                                    [disabled]="isColumnRestricted(column)" class="col-disable"> {{ column }}
                                  </label>
                                </div>
                              </div>
                          </div>                          
                    </div>
                                                                                            
                    <select name="status" id="deviceType" (change)="deviceTypeChange()" [(ngModel)]="deviceType"
                        class="mrl_20" style="cursor: pointer;">
                        <option value="all">Device Type - All</option>
                        <option *ngFor="let option of mainType" [value]="option">{{option}}</option>
                    </select>
            
                    <select name="subStatus" id="subType" (change)="subdeviceTypeChange()" [(ngModel)]="subType" *ngIf="deviceType !== 'all'" class="mrl_20 cursor">
                        <option value="">Type - All</option>
                        <option *ngFor="let subType of subTypes" [value]="subType">{{subType}}</option>
                    </select>
                    <input type="text" (keydown.enter)="searchChange()" 
                        placeholder="Search" [(ngModel)]="searchFilter" class="mrl_20"/>
                        <i class="fa fa-search icon_d_res" (click)="deviceTypeChange()"></i>
                    <select name="status" id="status" (change)="statusChange()" [(ngModel)]="siteFilter"
                        style="cursor: pointer;" class="mrl_20">
                        <option value="">Status - All</option>
                        <option value="1">UP</option>
                        <option value="0">DOWN</option>
                        <option value="2">SDT</option>
                        <option value="3">PM</option>
                        <option value="4">PAUSED</option>
                    </select>
                    <a *ngIf="loadingUserMessage != 'No data found'" [href]="csvPath" class="download"><i class="material-icons" matTooltip="Download CSV">file_download</i></a>
                        <button type="button" class="btn btn-primary btn-sm create-sdt"
                            [routerLink]="['/sdt-form']" (click)="createSdt()" *ngIf="((filteredMonitorsData.length > 0 && this.checkedCount >= 0) || (filteredMonitorsData.length > 0 && this.checkedCount <= 0)) && !isPmMainCheckboxChecked"
                            [hidden]="selectedPotentialId==0 || currentPage !== p">CREATE SDT
                        </button>
                        <button type="button" class="btn btn-primary btn-sm create-pm" *ngIf="(isPmMainCheckboxChecked || pmCount > 0)"
                            [routerLink]="['/planned-maintenance-form']" (click)="createPM()" id="createPMButton"
                            matTooltip="Create Planned Maintenance"
                            aria-label="Create Planned Maintenance" [hidden]="pmCount == 0">CREATE PM
                        </button>
                </div>            
                <div class="table-div" *ngIf="filteredMonitorsData.length > 0">
                    <div class="over-flow">
                    <table class="table table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col" (click)="sortItems('potentialId', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Potential<br>ID</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th scope="col" (click)="sortItems('siteName', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <div>Site Name</div>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th scope="col" (click)="sortItems('siteUnitId', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Site ID/ Unit ID</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
            
                                <th scope="col" (click)="sortItems('deviceName', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Device<br>Name</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['Device Type']" scope="col" (click)="sortItems('deviceType', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Device <br>Type</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th scope="col" (click)="sortItems('type', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Type</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['Camera Owned']" scope="col" (click)="sortItems('cameraOwnedBy', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Camera Owned By</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th *ngIf="deviceType == 'Camera'" scope="col" (click)="sortItems('monitoringService', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Monitoring Service</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['Device IP']" scope="col" (click)="sortItems('vpnIp', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Device IP</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['Port']" scope="col" (click)="sortItems('port', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Port</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['Interval']" scope="col" (click)="sortItems('interval', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Interval<br>(Sec)</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['Status']" scope="col" (click)="sortItems('status', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Status</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['Message']" scope="col" (click)="sortItems('message', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Message</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['Status Duration']" scope="col" (click)="sortItems('statusDuration', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>Status Duration</span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['Time Stamp']" scope="col" (click)="sortItems('createdDate', booleanValue)">
                                    <div class="d-flex align-items-center center">
                                        <span>TimeStamp <br>(CT) </span>
                                        <div class="pl-2">
                                            <div class="arrow-section"><i class="arrow up"></i></div>
                                            <div class="arrow-section"><i class="arrow down"></i></div>
                                        </div>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['SDT'] && showSDT">
                                    <div class="d-flex align-items-center">
                                        <span>SDT</span>
                                        <div class="sdt-mg">
                                            <input type="checkbox" id="sdt-cb" *ngIf="forPotentialId && !allDisabled() && this.searchResult && !checkUniquePotentialIds()"
                                                (change)="changeFiltervalue($event)">
                                        </div>
                                    </div>
                                </th>
                                <th *ngIf="columnVisibility['PM'] && showPM">
                                    <div class="d-flex align-items-center">
                                        <span matTooltip="Planned Maintenance">PM</span>
                                        <span class="align-center mg-left">
                                        <input type="checkbox" *ngIf="forPotentialIdPM && this.searchResult && upCountFlag() && !checkUniquePotentialIds()"
                                        (change)="selectAllPM($event)"
                                        [checked]="areAllPMSelected()">
                                        </span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let monitordata of filteredMonitorsData | paginate: { itemsPerPage: ipP, currentPage: p, totalItems: total}; let i = index;">
                                <td class="text-ctr">{{monitordata.potentialId || 'N/A'}}</td>
                                <td class="text-ctr">{{monitordata.siteName.replace(monitordata.siteUnitId,"") || 'N/A'}}</td>
                                <td class="compress_column1 text-ctr">{{monitordata.siteUnitId || 'N/A'}}</td>
                                <td class="text-ctr" (click)="monitordata.type === 'X310'|| monitordata.type === 'X410' ? showdeviceData(monitordata) : (monitordata.type === 'Axis') ? showCameraData(monitordata.deviceUqId) : (monitordata.type === 'Odroid') ? showMdcdata(monitordata) : (monitordata.type === 'Router' ? showRouterdata(monitordata) : null)" style="font-size: 18px;"><sub [ngStyle]="{'text-decoration': (monitordata.type === 'X310') || (monitordata.type === 'X410') || monitordata.type==='Axis' || monitordata.type === 'Odroid' || monitordata.type === 'Router' ? 'underline' : 'none','text-decoration-color': (monitordata.type === 'X310') || (monitordata.type === 'X410') || monitordata.type==='Axis' || monitordata.type === 'Odroid' || monitordata.type === 'Router' ? 'black' : 'black','cursor': monitordata.type === 'X310' || monitordata.type === 'X410' || monitordata.type==='Axis' || monitordata.type === 'Odroid' || monitordata.type === 'Router' ? 'pointer' : 'default'}">{{monitordata.deviceName || 'N/A'}}</sub>
                                    <sup *ngIf="selectedDevice?.includes(monitordata.deviceUqId)" class="sdt_highlight"><i>SDT</i></sup>
                                    <sup *ngIf="pmData?.includes(monitordata.deviceUqId)" class="sdt_highlight"><i>PM</i></sup>
                                </td>
                                <td class="text-ctr" *ngIf="columnVisibility['Device Type']">{{monitordata.deviceType || 'N/A'}}</td>
                                <td>
                                    <ng-container class="text-ctr" *ngIf="monitordata.deviceType == 'Alarm' && monitordata.subType=='STROBE' && columnVisibility['Type']">
                                      {{ monitordata.subType || 'N/A'}}
                                    </ng-container>
                                    <ng-container *ngIf="(monitordata.deviceType == 'Alarm' && monitordata.subType!='STROBE') || monitordata.deviceType != 'Alarm'">
                                      <div class="compress_column text-ctr">{{ monitordata.type || 'N/A'}}</div>
                                    </ng-container>
                                <td class="text-ctr" *ngIf="columnVisibility['Camera Owned']">{{monitordata.cameraOwnedBy || 'N/A'}}</td>
                                <td *ngIf="deviceType == 'Camera'" class="text-ctr">{{monitordata.monitoringService || 'N/A'}}</td>
                                <td class="text-ctr" *ngIf="columnVisibility['Device IP']">{{monitordata.vpnIp || 'N/A'}}</td>
                                <td class="text-ctr" *ngIf="columnVisibility['Port']">{{monitordata.port || 'N/A'}}</td>
                                <td class="text-ctr" *ngIf="columnVisibility['Interval']">{{monitordata.interval || 'N/A'}}</td>
                                <td class="text-ctr" *ngIf="columnVisibility['Status']">
                                    <span *ngIf="monitordata.status.toLowerCase() == 'up' && monitordata.servicePause !== 'Pause Service'" class="up-status"></span>
                                    <span *ngIf="monitordata.status.toLowerCase() == 'down' && monitordata.servicePause !== 'Pause Service'" class="down-status"></span>
                                    <span *ngIf="monitordata.status === 'Not Monitoring' && monitordata.servicePause !== 'Pause Service'" class="monitor-status"></span>
                                    <span *ngIf="monitordata.servicePause == 'Pause Service'" class="pause-status"></span>
                                </td>
                                <td class="text-ctr" *ngIf="columnVisibility['Message'] && monitordata.servicePause !== 'Pause Service'">{{(monitordata.status !== 'Not Monitoring' && monitordata.message) ? monitordata.message : 'Not Monitoring' || 'N/A'}}</td>
                                <td class="text-ctr" *ngIf="columnVisibility['Message'] && monitordata.servicePause == 'Pause Service'">Paused</td>
                                <td class="text-ctr" *ngIf="columnVisibility['Status Duration']">{{monitordata.statusDuration}}</td>
                                <td class="text-ctr" *ngIf="columnVisibility['Time Stamp']">{{monitordata.createdDate}}</td>
                                <td class="text-ctr check-box" *ngIf="!selectedDevice?.includes(monitordata.deviceUqId) && columnVisibility['SDT'] && showSDT">
                                    <input class="form-check-input form-input" type="checkbox" [id]='"checkbox"+i'
                                        (change)="changeValue($event,monitordata)"
                                        [disabled]="monitordata.zenTicketId == null || monitordata.status == 'Up' || !manageSdt || monitordata.servicePause == 'Pause Service'">
                                </td>
                                <td class="text-ctr" *ngIf="showSDTdetails(monitordata) && manageSdt">
                                    <div (click)="navigateDetails(monitordata?.deviceUqId)" class="cursor-vd">
                                      <img src="../../../assets/imgs/viewDetails.png" class="viewDetail">
                                    </div>
                                  </td>
                                  <td class="text-ctr" *ngIf="showSDTdetails(monitordata) && !manageSdt">
                                    <div style="text-align: center;">
                                      <img src="../../../assets/imgs/viewDetails.png" class="viewDetail">
                                    </div>
                                  </td>
                                  <td *ngIf="!pmData?.includes(monitordata?.deviceUqId) && columnVisibility['PM'] && showPM">
                                      <div class="align-center"> 
                                        <input [id]='"pmcheckbox"+i' 
                                               [disabled]="isPMcheckboxDisabled(monitordata)"
                                               (change)="changeValue1($event,monitordata)"
                                               class="form-check-input fm-input" 
                                               type="checkbox"
                                               [(ngModel)]="monitordata.pmSelected">
                                        </div>
                                    </td>
                                    <td class="text-ctr cursor-vd" *ngIf="showPMdetails(monitordata) && viewPlannedMaintenance">
                                        <div (click)="sendData(monitordata.timeZone)"> 
                                          <img (click)="navigateDetailsPM(monitordata?.deviceUqId, monitordata?.potentialId, monitordata?.siteUnitId,monitordata?.timeZone)"
                                               src="../../../assets/imgs/viewDetails.png" class="viewDetail">
                                        </div>
                                      </td>
                                      <td class="text-ctr" *ngIf="showPMdetails(monitordata) && !viewPlannedMaintenance">
                                        <div class="align-center"> 
                                          <img src="../../../assets/imgs/viewDetails.png" class="viewDetail">
                                        </div>
                                      </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                    <div class="footer-section">
                        <span class="mr-3"><b>Items per page:</b>{{ipP}}</span>
                        <span><b>{{100 * p - ipP + 1}} - {{(size !== ipP) ? total : (100 * p) }}</b> of
                            <b>{{total}}</b></span>
                        <pagination-controls (pageChange)="p = $event; getNewItems(p);"></pagination-controls>
                    </div>
                </div>    
            </div>
            <div *ngIf="filteredMonitorsData.length == 0" class="no-data text-primary m-t-15 load-mg">
                {{loadingUserMessage}}
            </div>
        </article>
        <article *ngIf="isPageError" class="site-page-error">
            <p class="site-page-errorMsg page-load">{{pageLoadMessage}}</p>
        </article> 
    </div>
</section>

<div class="mainbox deviceModel" id="myModal1" [ngStyle]="{'display':displayStyle}">
    <div class="model_sub_box">
        <div (click)="closePopup()" class="close_button_box">
            <button type="button" class="close devicebtn">&times;</button>
        </div>
        <app-solar-script-dialog [deviceInfoData]="deviceInfoDataObj"></app-solar-script-dialog>
    </div>
</div>

<div class="mainbox1 cameraModel" id="myModal2">
    <div class="model_sub_box1 cam-width">
        <div (click)="closeCameraPopup()" class="close_1_button">
            <button type="button" class="close camBtn">&times;</button>
        </div>
        <app-camera-meta-data [cameraMetadata]="cameraMeta"></app-camera-meta-data>
    </div>
</div>

<div class="mainbox1 cameraModel" id="myModal3">
    <div class="model_sub_box2 width-max">
        <div (click)="closeMdcdata()" class="close_1_button">
            <button type="button" class="close camBtn">&times;</button>
        </div>
        <app-mdc-data [mdcData]="mdcMetadata"></app-mdc-data>
    </div>
</div>

<div class="mainbox1 cameraModel" id="myModal4">
    <div class="model_sub_box2" style="width:100% !important">
        <div (click)="closeRouterInfo()" class="close_1_button">
            <button type="button" class="close camBtn" style="line-height: 20px;">&times;</button>
        </div>
        <app-router-info [routerData]="routerInfo"></app-router-info>
    </div>
</div>